export const validateEMAIL = (value) => {
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(value);
};

export const validateName = (value) => {
  const regex = /^[A-Za-z\s]*$/;
  return regex.test(value.trim());
};

export const validatePhoneNumber = (value) => {
  const regex = /^\d{0,10}$/;
  return regex.test(value);
};
